import { SALES_INVOICES_INDEX } from "./invoices";

// Price Quotations — price_quotations.* (menu_item_id 1, Invoice Management)
//
// Backend keys are registered by the amer-laravel migration
// 2026_07_29_100007_add_price_quotation_permissions. The ids below are the
// central-assigned approval numbers, confirmed against the central permission-key
// registry on 2026-07-31.

/** price_quotations.index */
export const PRICE_QUOTATIONS_INDEX = 1426;
/** price_quotations.show */
export const PRICE_QUOTATIONS_SHOW = PRICE_QUOTATIONS_INDEX;
/** price_quotations.create */
export const PRICE_QUOTATIONS_CREATE = 1428;
/** price_quotations.update */
export const PRICE_QUOTATIONS_UPDATE = 1429;
/** price_quotations.change_status */
export const PRICE_QUOTATIONS_CHANGE_STATUS = 1430;
/** price_quotations.send */
export const PRICE_QUOTATIONS_SEND = 1431;
/** price_quotations.comment */
export const PRICE_QUOTATIONS_COMMENT = 1432;
/** price_quotations.convert */
export const PRICE_QUOTATIONS_CONVERT = 1433;
/** price_quotations.print */
export const PRICE_QUOTATIONS_PRINT = 1434;
/** price_quotations.download */
// Producing the document is one capability: download is gated by the print permission.
export const PRICE_QUOTATIONS_DOWNLOAD = PRICE_QUOTATIONS_PRINT;
/** price_quotations.delete */
export const PRICE_QUOTATIONS_DELETE = 1436;
/** price_quotations.restore */
export const PRICE_QUOTATIONS_RESTORE = 1437;

// Reports — reports.sales.* (menu_item_id 19, Reports Management)
//
// Registered by the amer-laravel migration
// 2026_07_29_100008_add_price_quotation_report_permissions. Confirmed against the
// central permission-key registry on 2026-07-31, in the same batch as the twelve
// above.
/** reports.sales.price-quotations-register */
export const SALES_REPORTS_QUOTATIONS_REGISTER = 1438;
/** reports.sales.price-quotation-conversion */
export const SALES_REPORTS_QUOTATION_CONVERSION = 1439;

/** No key of its own: the sales invoices register's readers. */
export const SALES_REPORTS_INVOICE_ANALYSIS = SALES_INVOICES_INDEX;

/** Sidebar gate: the sales-reports hub is reachable with any of its reports. */
export const SALES_REPORTS_PERMISSIONS = [
  SALES_REPORTS_QUOTATIONS_REGISTER,
  SALES_REPORTS_QUOTATION_CONVERSION,
  SALES_REPORTS_INVOICE_ANALYSIS,
];
